/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import AKBadge from '@atlaskit/badge';
import { fg } from '@atlaskit/platform-feature-flags';
var badgeStylesOld = null;
var badgeStyles = null;

/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */

var AtlaskitBadge = function AtlaskitBadge(_ref) {
  var value = _ref.value,
    name = _ref.name,
    className = _ref.className,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-element-atlaskit-badge' : _ref$testId;
  if (!value) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, fg('platform-linking-visual-refresh-v1') ? {} : _defineProperty({}, 'data-fit-to-content', true), {
    "data-smart-element": name,
    "data-smart-element-atlaskit-badge": true,
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: ax([!fg('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y", fg('platform-linking-visual-refresh-v1') && "_4cvr1h6o _1e0c116y _1ul91ns9", className])
  }), /*#__PURE__*/React.createElement(AKBadge, null, value));
};
export default AtlaskitBadge;